import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=28421cbc&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28421cbc')) {
      api.createRecord('28421cbc', component.options)
    } else {
      api.reload('28421cbc', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=28421cbc&", function () {
      api.rerender('28421cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/supplier/edit.vue"
export default component.exports